import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// PropTypes
import { jobPropTypes } from '../../../../proptypes/jobProptypes';
import { companyPropTypes } from '../../../../proptypes/companyProptypes';

// Context
import ApproachContext from '../../../../context/ApproachContext';

// Styles
import styles from './summarySection.module.scss';

const SummarySection = ({ job, company }) => {
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  if (!job.extra_info?.summary) return null;

  return (
    <section id="summary-section" className={styles.summary}>
      <h2 className={styles.heading}>
        {job.is_one_landing_page
          ? t(`description_page.summary_section.olp_title.${approach}`, {
              company: company.company_name,
            })
          : t(`description_page.summary_section.title.${approach}`)}
      </h2>
      <div
        className={`html-div ${styles.content}`}
        dangerouslySetInnerHTML={{
          __html: job.extra_info?.summary,
        }}
      />
    </section>
  );
};

SummarySection.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
  company: PropTypes.shape(companyPropTypes).isRequired,
};

export default SummarySection;
